module.exports = __webpack_public_path__ + "media/images/anonyme-192e180554f573dfb40c31b0c7dd0765.svg";